import * as React from 'react';

export interface IProps {}

const Customers: React.SFC<IProps> = () => <h2>Customers</h2>;

export default Customers;
